import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, ADMIN_TOKEN, errMsg } from "@/lib/api";
import { Emblem } from "@/components/Logo";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem(ADMIN_TOKEN, data.token);
      nav("/admin", { replace: true });
    } catch (e2) {
      setErr(errMsg(e2));
      setBusy(false);
    }
  };
  return (
    <main className="min-h-screen bg-plum grid place-items-center p-4" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-[420px] rounded-[22px] bg-pearl p-8 sm:p-10">
        <Emblem className="w-12 h-11 text-plum" gem="var(--rh-accent)" />
        <p className="font-display text-[22px] tracking-[0.28em] font-semibold mt-4">RATNAHARA</p>
        <h1 className="font-display text-[36px] font-semibold mt-6 leading-none">Admin sign in</h1>
        <div className="space-y-4 mt-8">
          <label className="block"><span className="block text-[14px] font-bold mb-1.5">Email</span><input className="rh-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" data-testid="admin-login-email" required /></label>
          <label className="block"><span className="block text-[14px] font-bold mb-1.5">Password</span><input className="rh-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" data-testid="admin-login-password" required /></label>
        </div>
        {err && <p className="mt-4 text-[14px] font-semibold text-ruby" data-testid="admin-login-error">{err}</p>}
        <button disabled={busy} className="mt-7 w-full h-14 rounded-[14px] bg-plum text-pearl font-extrabold uppercase tracking-[0.14em] text-[13px] hover:bg-berry transition-colors flex items-center justify-center gap-2" data-testid="admin-login-submit">
          {busy && <Loader2 className="w-4 h-4 animate-spin" />}Sign in
        </button>
      </form>
    </main>
  );
}
